import { render, staticRenderFns } from "./PurchaseServiceList.vue?vue&type=template&id=55599c18"
import script from "./PurchaseServiceList.vue?vue&type=script&lang=js"
export * from "./PurchaseServiceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports